import { useEffect, useState } from 'preact/hooks'
import type { Store } from '../net/store'

/** The store's current value; re-renders the component when it changes. */
export function useStore<T>(store: Store<T>): T {
  const [value, setValue] = useState(() => store.get())
  useEffect(() => {
    setValue(() => store.get())
    return store.subscribe((v) => setValue(() => v))
  }, [store])
  return value
}
